import { render, staticRenderFns } from "./SourceDocumentView.vue?vue&type=template&id=743f64ee&scoped=true"
import script from "./SourceDocumentView.vue?vue&type=script&lang=js"
export * from "./SourceDocumentView.vue?vue&type=script&lang=js"
import style0 from "./SourceDocumentView.vue?vue&type=style&index=0&id=743f64ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "743f64ee",
  null
  
)

export default component.exports